import React from "react";

import { TitleL } from "../../../components/Elements";
import Contents from "./Contents";
import CardSection from "./CardSection";
import { Container } from "./styled";

const PageContents = () => {
  return (
    <Container>
      <TitleL talign="left">Our Story</TitleL>
      <Contents />
      <CardSection />
    </Container>
  );
};

export default PageContents;
